import { Org, type ApiOrg } from './org';
import { Team, type ApiTeam } from './teams';
import { type ApiPermission } from './permissions';

export interface ApiUser {
  email: string;
  first_name: string;
  last_name: string;
  twrn: string;
  profile_photo: string | null;
  is_super_admin: boolean;
  axle_twrn: string;
}

export class User {
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  twrn: string;
  avatar: string | null = null;
  isSuperAdmin: boolean;
  axleTwrn: string;
  constructor(data: ApiUser) {
    this.email = data.email;
    this.firstName = data.first_name;
    this.lastName = data.last_name;
    this.fullName = `${data.first_name} ${data.last_name}`;
    this.twrn = data.twrn;
    this.avatar = data.profile_photo;
    this.isSuperAdmin = data.is_super_admin;
    this.axleTwrn = data.axle_twrn;
  }
}

export interface ApiMe {
  user: ApiUser;
  org: ApiOrg;
  teams: ApiTeam[];
  permissions: ApiPermission[];
}

export class Me {
  user: User;
  org: Org;
  teams: Team[];
  permissions: ApiPermission[];

  constructor(data: ApiMe) {
    this.user = new User(data.user);
    this.org = new Org(data.org);
    this.teams = data.teams.map((team) => new Team(team));
    this.permissions = data.permissions;
  }
}
